import { ArrowForward, InfoOutlined } from "@mui/icons-material";
import { Alert, Box, Button, Stack, Typography } from "@mui/material";
import OnboardingConfiguredListSection from "features/onboarding/components/OnboardingConfiguredListSection";

const INTERACTIONS = [
  "[Location name] Link Clicked",
  "Add to Basket",
  "Cart Viewed",
  "Checkout Started",
];

const PAGE_RULES = [
  "Add to Cart triggered",
  "Click to triggered",
  "90+ seconds on a product page",
  "Blog page: 90+ seconds and 50%+ scroll depth",
];

const SESSION_RULES = [
  "1+ macro conversion fired",
  "1+ sale",
  "50%+ Effective Pageviews",
];

interface IOnboardingEventsAndConversionsProps {
  onContinue: () => void;
}

function OnboardingEventsAndConversions({
  onContinue,
}: IOnboardingEventsAndConversionsProps) {
  return (
    <Stack
      spacing={3}
      justifyContent="space-between"
      sx={{ height: "100%", minHeight: 0 }}
    >
      <Box sx={{ flex: 1, minHeight: 0, overflow: "auto" }}>
        <Typography variant="h6" fontWeight={600} gutterBottom>
          Events and conversions configured
        </Typography>

        <Stack spacing={2}>
          <OnboardingConfiguredListSection
            title="Interactions"
            items={INTERACTIONS}
            showDivider={false}
          />
          <OnboardingConfiguredListSection
            title="Page-level Effectiveness Rules"
            items={PAGE_RULES}
          />
          <OnboardingConfiguredListSection
            title="Session-level rules"
            items={SESSION_RULES}
          />
        </Stack>

        <Alert
          severity="info"
          icon={<InfoOutlined />}
          sx={{
            mt: 3,
            bgcolor: "action.hover",
            color: "text.primary",
            "& .MuiAlert-icon": { color: "primary.main" },
          }}
        >
          <Typography variant="body2">
            These signals power your Effectiveness metric — a single score that
            shows how well each page and session drives results.
          </Typography>
        </Alert>
      </Box>

      <Button
        fullWidth
        variant="contained"
        color="primary"
        size="large"
        endIcon={<ArrowForward />}
        onClick={onContinue}
        sx={{ flexShrink: 0 }}
      >
        Continue
      </Button>
    </Stack>
  );
}

export default OnboardingEventsAndConversions;
